<template>

  <div class="container-fluid">
    <CRow class="mb-4">
      <h2 v-if="selectedTemplateName">{{selectedTemplateName}} Template Events</h2>
    </CRow>
    
    <listing-action
        :deleteHandler="deleteRecords"
        :createHandler="createRecord"
    ></listing-action>

    <search-items v-model="params.search" :searchHandler="searchTemplateEvents" :placeholder="'Type to search'"></search-items>

    <b-table
        :items="fields"
        :fields="headers"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @sort-changed="sortingChanged"
        sort-icon-left
    >
      <template #cell(id)="{item}">

          <b-form-checkbox
              :id="'checkbox_'+item.id"
              v-model="checkbox"
              name="checkbox-1"
              :value="item.id"
              unchecked-value="not_accepted"
          >
          </b-form-checkbox>

      </template>
      <template #cell(file_url)="{item}">

        <div v-if="item.file_url">
          <div v-if="showImage(item.file_url)" class="d-flex align-items-start">
            <img style="max-width: 100px; max-height: 100px; height: auto; width: auto" class="img-fluid"
                 :src="base_url+'/'+item.file_url" @click="enlargeImage(base_url+'/'+item.file_url)" alt="..."/>
          </div>

          <a class="d-block download-link" v-else target="_blank"
             :href="base_url+'/'+item.file_url">Download File
            <BIconDownload class="ml-1"/>
          </a>

        </div>


      </template>
      <template #cell(event_time)="{item}">
        {{item.event_time|formatDate}}
      </template>
      <template #cell(actions)="item">
        <edit class="delete_step ml-2" @click="editYearlyPlannerEvent(item.item)" fillColor="#009FE3" />
        <delete class="delete_step ml-2" @click="deleteYearlyPlannerEvent(item.item.id)" fillColor="#E30000" />
      </template>
    </b-table>

    <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.rows"
        :per-page="pagination.perPage"
        aria-controls="itemList"
        align="center"
        @change="handlePagination"
        v-if="pagination.total > 0"
        :key="pagination.currentPage"
    ></b-pagination>

    <b-modal id="addTemplateModal" size="lg" no-close-on-backdrop  hide-footer>
      <template #modal-title>
        <span>Yearly Planner Events</span>
      </template>
      <div class="row">
        <div class="col-lg-8">
          <div class="row">
            <div class="col-md-12">
              <b-form-group
                  label="Event title"
                  labelClass="required"
              >
                <b-form-input
                    type="text"
                    placeholder="Title"
                    v-model="form.title"
                    name="title"
                    v-validate="{required: true}"
                ></b-form-input>
                <div v-if="errors && errors.first('title')" class="error_msg">
                  The title field is required.
                </div>
              </b-form-group>
            </div>

            <div class="col-md-12">
              <b-form-group
                  label="Event Due"
                  labelClass="required"
              >
                <date-picker :config="datepickerOptions" value="form.event_time" v-validate="{required: true}"
                             v-model="form.event_time"></date-picker>
                <div v-if="errors && errors.first('event_time')" class="error_msg">
                  Event time is required.
                </div>
              </b-form-group>
            </div>

            <div class="col-md-12">
              <b-form-group
                  label="Event description"
                  labelClass="required"
              >
                <b-form-input
                    type="text"
                    placeholder="Event description"
                    v-model="form.description"
                    name="description"
                    v-validate="{required: true}"
                ></b-form-input>
                <div v-if="errors && errors.first('description')" class="error_msg">
                  The description field is required.
                </div>
              </b-form-group>
            </div>

            <div class="w-100">
              <div class="col-md-12 d-flex align-items-center" style="margin-top: 10px; gap: 15px">
                <div>
                  <b-form-checkbox v-model="form.is_reminder" :checked="form.is_reminder"><span
                    class="d-inline-flex" style="white-space: nowrap">Send reminder</span></b-form-checkbox>
                </div>

                <div class="w-100" v-if="form.is_reminder">
                  <b-form-select name="before_time"  v-validate="{required: true}" v-model="form.before_time" :options="getReminders"></b-form-select>
                  <div v-if="errors && errors.first('before_time')" class="error_msg">
                    Select reminder option.
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12" v-if="form.is_reminder">
              <b-form-group
                  label="Email Template"
                  labelClass="required"
              >
                <b-form-select name="email_template_index"  v-validate="{required: true}" @change="setEventEmailTemplate"
                               v-model="email_template_index" :options="emailTemplateOptions"></b-form-select>
                <div v-if="errors && errors.first('email_template_index')" class="error_msg">
                  Email template is required.
                </div>
              </b-form-group>
            </div>



          </div>
        </div>
        <div class="col-lg-4">

            <div class="custom"  >
              <div class="modal-handler">

                <label class="upload-box position-relative">
                  <a class="remove" v-if="file_data" @click="deleteFile">
                    <BIconX/>
                  </a>
                  <template v-if="file_data">
                    <div class="uploaded-logo-holder">
                       <img  crossorigin="anonymous" v-if="showPlaceholder" :src="file_data" style="width: 100%; max-width: 150px"/>
                      <div v-else> <BIconFileEarmark/></div>
                    </div>
                    <span class="file_name">{{ file_name }}</span>
                    <a class="d-block download-link" v-if="is_file_download && form.id>0" target="_blank"
                       :href="file_data">Download File <BIconDownload class="ml-1" /></a>
                  </template>

                  <div v-if="!file_data">
                    <div class="text-center img-thumbnail">
                      <div class="icon-holder fs-4">
                        <BIconImage/>
                      </div>
                      <slot name="upload_text">
                        <div class="fs-2 mt-1">Upload File</div>
                      </slot>
                    </div>

                    <div style="opacity: 0; height: 0; overflow: hidden">
                      <b-form-file
                          type="file"
                          name="file" ref="fileInput"
                          v-model="form.file"
                          @input="uploadEventImage"
                          class="fileLoader"
                          accept="image/*"
                       ></b-form-file>
                    </div>

                  </div>

                </label>

              </div>
            </div>

        </div>

        <div class="col-12 text-right mt-3">
          <b-button variant="primary" @click="saveYearlyPlannerEvent">Save</b-button>
        </div>
      </div>
    </b-modal>
    <ViewImage ref="viewImageRef" />
  </div>
</template>
<script>
import Delete from 'vue-material-design-icons/Delete';
import Edit from 'vue-material-design-icons/CircleEditOutline';
import datePicker from 'vue-bootstrap-datetimepicker';
import moment from 'moment'
import {http} from "@/config/httpCommon"
import ViewImage from "@/components/ViewImage";
import {getLastPage, getPageModal, removePageModal, setPageModal} from "@/helpers/Helpers";
import SearchItems from "@/components/SearchItems.vue";

export default {
 components: {
    Delete,
    Edit,
    datePicker,
   ViewImage,
   SearchItems
  },
  async created(){

    this.$store.commit('set', ['showLoader', true]);
    this.form.yearlyplanner_template_id = this.$route.params.id
    this.getPlannerTemplate();
    this.preservePaginationIgnoreSearch('page', 'search', this.$route.name, this.getYearlyPlannerEvents);
    this.getEventEmailTemplates();
    this.$store.commit('set', ['showLoader', false]);

  },
  filters: {
    formatDate: (value) => {
     if (value) {
        return moment(String(value)).format('MM/DD/YYYY hh:mm A')
      }
    }
  },
  data(){
    return {
      yearly_planner_events:[],
      event_email_templates:[],
      selectedTemplateName:'',
      fields: [],
      form: {
        id: 0,
        yearlyplanner_template_id:0,
        title: '',
        event_type: 'custom',
        description: '',
        event_time: '',
        is_reminder: false,
        before_time: null,
        email_template_id: null,
        email_content: '',
        file: null
      },
      eventTypeOptions : [{text:'Please select a type', value:''},{text: 'Custom event', value: 'custom'}],
      datepickerOptions:  {
        format: 'YYYY-MM-DD HH:mm:ss',
        minDate: new Date(),
        icons: {
          time: 'far fa-clock',
          date: 'far fa-calendar',
          up: 'fas fa-arrow-up',
          down: 'fas fa-arrow-down',
          previous: 'fas fa-chevron-left',
          next: 'fas fa-chevron-right',
          today: 'fas fa-calendar-check',
          clear: 'far fa-trash-alt',
          close: 'far fa-times-circle'
        }
      },
      emailTemplateOptions: [],
      email_template_index : null,
      file_data:null,
      file_name:null,
      is_file_download:false,
      checkbox: [],
      base_url: process.env.VUE_APP_FILE_URL,
      headers: [
        {key: 'id', label: '',sortable: false},
        {key: 'title', label: 'Title', sortable: true},
        {key: 'event_time', label: 'Event Time', sortable: true},
        {key: 'description', label: 'Description', sortable: true},
        {key: 'file_url', label: 'File', sortable: false},
        {key: 'actions', label: 'Actions', sortable: false},
      ],
      pagination:{
        rows:null,
        currentPage:null,
        perPage:null,
        total:0
      },
      sortBy: 'event_time', //Field key for sorting by (or null for no sorting
      sortDesc: false,
      params: {
        sortBy: '', //Field key for sorting by (or null for no sorting
        sortOrder: false, // true if sorting descending, false otherwise
        search:'',
        page : 1,
      },
      showPlaceholder : true
     }
  },
  computed: {
    getSortOrder() {
      return this.sortDesc ? 'DESC' : 'ASC'
    },
    getSortField() {
      return this.sortBy
    },
    getReminders(){
      const optionArray = [];
      optionArray[0] = {value: null, text: 'Choose an option'}
      optionArray[1] = {value: 1440, text: '1 day before'}
      optionArray[2] = {value: 4320, text: '3 days before'}
      optionArray[3] = {value: 10080, text: '7 days before'}
      optionArray[4] = {value: 43200, text: '1 month before'}
      return optionArray;
    }
  },
  methods:{
    sortingChanged() {
      this.getYearlyPlannerEvents()
    },
    searchTemplateEvents(search){
      this.params.page = 1;
      setPageModal(1,this.$route.name,this.params);
      this.getYearlyPlannerEvents();
    },
    async getPlannerTemplate() {
      this.params.yearly_template_id = this.form.yearlyplanner_template_id
      let res = await http.get(`yearly-template/${this.form.yearlyplanner_template_id}`);
      if(res.status == 200){
       this.selectedTemplateName = res.data.name
      }
    },
    async getYearlyPlannerEvents() {
      this.$store.commit('set', ['showLoader', true]);
      //make params
      this.params.yearly_template_id = this.form.yearlyplanner_template_id
      this.params.sortBy = this.getSortField
      this.params.sortOrder = this.getSortOrder
      let params = new URLSearchParams(this.params);
      setPageModal(this.params.page,this.$route.name,this.params);
      params = '?'+params.toString();
      let res = await http.get(`yearly-planner-template-events` + params);
      this.yearly_planner_events = res.data.data
      this.$store.commit('set', ['showLoader', false]);
      this.fields = this.yearly_planner_events;
      this.makePagination(res.data);
    },
    async handlePagination(page=''){
      this.params.page = page
      setPageModal(this.params.page,this.$route.name,this.params);
      this.getYearlyPlannerEvents();
    },
    makePagination(data){
      this.pagination.currentPage = data.meta.current_page;
      this.pagination.rows = data.meta.total;
      this.pagination.perPage = data.meta.per_page;
      this.pagination.total = data.meta.total;
    },
    ResetForm(){
      this.$bvModal.show("addTemplateModal");
    },
    async getEventEmailTemplates() {
      let res = await http.get('get-all-email-templates?type=event');
      this.event_email_templates = res.data

      const optionArray = [];
      optionArray[0] = {value: null, text: 'Select an email template'}
      res.data.map(function (obj, index) {
        optionArray.push({value: index, text: obj.title});
      })
      this.emailTemplateOptions = optionArray
    },
    async saveYearlyPlannerEvent(){
      let valid = await this.$validator.validate();
      if(valid){
        try {
          this.$store.commit('set', ['showLoader', true]);

          if(!this.form.is_reminder){
            this.form.email_template_id = '';
            this.form.email_content = '';
            this.form.before_time = '';
          }

          let form = new FormData()
          for (const key in this.form) {
            if (key == 'is_reminder') {
              if (this.form[key]) {
                form.append(key, 1);
              } else {
                form.append(key, 0);
              }
            }else if(key == 'before_time' && this.form[key] !== null){
              form.append(key, '['+this.form[key]+']');
            } else {
              form.append(key, this.form[key]);
            }

          }


          if(this.form.id > 0){
            if(!this.file_data){
              form.append('delete_file',1);
            }
            await this.updateYearlyPlannerEvent(form);
            this.fields = this.yearly_planner_events;
            this.preservePagination( 'page', 'search', this.$route.name, this.getYearlyPlannerEvents)
          }else{
            await this.createYearlyPlannerEvent(form);
            this.fields = this.yearly_planner_events;
            this.nextPageOnCreation('page','search', this.fields.length - 1, this.pagination.perPage, this.pagination.currentPage, getLastPage(this.pagination.perPage ,this.pagination.total ), this.$route.name, this.getYearlyPlannerEvents);
          }
          this.$store.commit('set', ['showLoader', false]);
          this.$bvModal.hide("addTemplateModal");
        }catch (err){
          this.$store.commit('set', ['showLoader', false]);
          this.showError(err);
        }
      }
    },
    createRecord(){
      this.form.id = 0
      this.form.title =  ''
      this.form.event_type = 'custom'
      this.form.description =  ''
      this.form.event_time = ''
      this.form.is_reminder = false
      this.form.before_time = null
      this.email_template_index = null
      this.form.email_template_id = null
      this.form.email_content = ''
      this.deleteFile()
      this.$bvModal.show("addTemplateModal");
    },
    async createYearlyPlannerEvent(payload) {
      let res = await http.post(`yearly-planner-template-events`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      if (res.status == 201) {
        this.yearly_planner_events.push(res.data.data)
        this.showToast('Event saved successfully','SUCCESS')
      }
      return res;
    },
    async updateYearlyPlannerEvent(payload) {

      let id = payload.get('id');
      let res = await http.post(`yearly-planner-template-events/${id}?_method=PUT`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      });
      if (res.status == 200) {
        let savedItem = res.data.data
        this.yearly_planner_events = this.yearly_planner_events.map(item => {
          if (item.id === savedItem.id)
            return savedItem;
          else
            return item;
        });
        this.showToast('Event saved successfully','SUCCESS')
      }
      return res;
    },
    async deleteYearlyPlannerEvents(payload) {
      await http.delete(`yearly-planner-template-events/1`, {data: payload});
      payload.ids.forEach(id => {
        let index = this.yearly_planner_events.findIndex(item => item.id == id);
        this.yearly_planner_events.splice(index, 1);
      });
      this.fields = this.yearly_planner_events;
      this.previousPageOnDeletion('page','search',this.fields.length,this.$route.name,this.getYearlyPlannerEvents);
    },
    async deleteRecords(){
      if(this.checkbox.length > 0){
        try {
          let payload = {
            ids: this.checkbox
          }
          this.$confirm('Are you sure to delete selected event/s?').then(async ()=>{
            this.$store.commit('set', ['showLoader', true]);
            await this.deleteYearlyPlannerEvents(payload);
            this.fields = this.yearly_planner_events;
            this.previousPageOnDeletion('page','search',this.fields.length,this.$route.name,this.getYearlyPlannerEvents);
            this.showToast('Events deleted successfully','SUCCESS')
            this.$store.commit('set', ['showLoader', false]);
            this.checkbox = [];
          }).catch(_ => {
            console.log(_);
          })
        }catch (e) {
          this.$store.commit('set', ['showLoader', false]);
          this.showErrors(e);
        }
      }else{
        this.showToast('Atleast select 1 template', 'DANGER');
      }
    },
    async deleteYearlyPlannerEvent(id){
      try {

        let payload = {
          ids: [id]
        }
        this.$confirm('Are you sure to delete this event?').then(async ()=>{
          this.$store.commit('set', ['showLoader', true]);
          await this.deleteYearlyPlannerEvents(payload);
          this.showToast('Event deleted successfully','SUCCESS')
          this.$store.commit('set', ['showLoader', false]);
        }).catch(_ => {
          console.log(_);
        })
      }catch (e) {
        this.showErrors(e);
        this.$store.commit('set', ['showLoader', false]);
      }
    },
    editYearlyPlannerEvent(item){
      this.form.id = item.id;
      this.form.title = item.title;
      this.form.event_type = 'custom'
      this.form.description = item.description;
      this.form.event_time = item.event_time;
      this.form.is_reminder = (item.is_reminder == 1)?true:false

      let before_time = null
      if(item.is_reminder == 1 && item.before_time !== null){
       let before_time_arr = JSON.parse(item.before_time)
        before_time = before_time_arr[0]
      }

      this.form.before_time = before_time
      if(item.email_template_id){
        this.form.email_template_id = parseInt(item.email_template_id)
        this.form.email_content = item.email_content
      }

      if(item.email_template_id){
        let emailTemplates = this.event_email_templates
        this.email_template_index = emailTemplates.map(function (eTemplate) {
          return eTemplate.id;
        }).indexOf(this.form.email_template_id);
      }


      if(item.file_url){
        if(!this.showImage(item.file_url)){
          this.showPlaceholder = false
        }else{
          this.showPlaceholder = true
        }

        this.file_data = this.base_url +'/'+item.file_url
        this.file_name = ''
        this.form.file = null
        this.is_file_download = true
      }else{
        this.file_data = null
        this.file_name = ''
        this.form.file = null
        this.is_file_download = false

      }
      this.$bvModal.show("addTemplateModal");

    },
    setEventEmailTemplate(index) {
      if (index !== null) {
        let template = this.event_email_templates[index];
        this.form.email_template_id = template.id
        this.form.email_content = template.content
      } else {
        this.form.email_template_id = null
        this.form.email_content = ''
      }
    },
    uploadEventImage() {
      let event_data_file = this.form.file;

      if(!this.showImage(event_data_file.name)){
        this.showPlaceholder = false
      }else{
        this.showPlaceholder = true
      }
      if ((event_data_file.size / 1024) <= 2048) {
        this.file_name = event_data_file.name;
        this.file_data = URL.createObjectURL(this.form.file);
      }
    },
    deleteFile() {
      this.file_data = null
      this.file_name = null
      this.form.file = null
      this.is_file_download = false
     },
    showImage(file_url){
      if(file_url){
        let extensions = ["jpg","png","jpeg","gif"];
        let ext = file_url.split('.').pop();
        if(extensions.includes(ext)){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
    },
    enlargeImage(url){
      this.$refs["viewImageRef"].imagePreview(url);
    }


  }
}
</script>
<style lang="scss" scoped>
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css");
.add_field_btn{
  width: 125px;
  .float-right{
    line-height: 0;
  }
}
.delete_addons, .edit_addons{
  cursor: pointer;
}
.img-thumbnail{
  width: 200px;
}

.remove{
  position: absolute;
  top: -10px;
  right: -10px;
  height: 20px;
  width: 20px;
  background: firebrick;
  color: #fff !important;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1000px;
  box-shadow: 0 0 0 1px #fff;
}

.download-link{
  text-decoration: none;
  color: #333;
  text-align: center;
  padding: 5px;
}
</style>
